import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { DiceService } from '../_services/dice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NgbDateParserFormatter, NgbDateStruct, NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { StatusCode, QuoteStatus, BillingType, DocumentFileType, ContactRoleType, LOBType, DefaultPaymentPlan, NewBusiness, CustomInputType, LobCodes, LobStatus, YesNo, EditorOptionTypeEnum, DocumentExtensionEnum, LOBTypeDisplayName } from 'src/app/_common/_enum/module.enum';
import { PRODUCT_CONFIG, DICE_QUOTES_CONFIG, FILE_UPLOAD_CONFIG, FORM_MSGS } from '../../_common/product-config';
import { BindQuote, Billing, AuditContact, BillingContact, DiceQuoteMethod } from '../_models/dice-quote';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-bind-nissue',
  templateUrl: './bind-nissue.component.html',
  styleUrls: ['./bind-nissue.component.scss']
})
export class BindNIssueComponent implements OnInit {
  private headerData: HeaderData;
  private quoteResponse: any;
  private quote: any;
  private application: any;
  private lookupReferenceData: any;
  private billingConfig = Billing;
  private auditContact = {
    firstName: null, lastName: null, roleName: 'Audit', email: null, phone: null
  };
  private wcAuditContact = {
    firstName: null, lastName: null, roleName: 'WCAudit', email: null, phone: null
  };
  private billingContact = {
    firstName: null, lastName: null, roleName: 'Billing', email: null, phone: null
  };

  private billingTypeEnum = BillingType;
  private contactRoleTypeEnum = ContactRoleType;
  private documentFileTypeEnum = DocumentFileType; // Using it in HTML
  private lobTypeEnum = LOBType; // Using it in HTML
  private customInputTypes = CustomInputType; // Using it in HTML
  private yesNoEnum = YesNo;

  private supportingDocuments = [];
  private directPaymentPlans: any = [];
  private agencyPaymentPlans: any = [];
  
  private quoteStatusConfig = QuoteStatus;
  private diceQuoteConfig = DICE_QUOTES_CONFIG;
  private productConfig = PRODUCT_CONFIG;
  private fileUploadConfig = FILE_UPLOAD_CONFIG;
  private formMsgs = FORM_MSGS;
  private errorMessages = this.diceQuoteConfig.FormErrorMessages; // Using it in HTML

  private bindQuoteForm: any;

  private policyEffectiveDate = {};
  private policyMaxDate = {};
  private policyDateMaxDays: number = this.productConfig.DiceEffectiveDateRange;   //Policy Effective Date on Calendar will be 60 days starting tomorrow
  private isDisabledDates: any; //(date: NgbDate, current: {month: number}) => date.day === 13;

  private isMNExempt: boolean = false;
  private isWCFeinOverridden: boolean = false;
  private isWorkCompReferred: boolean = false;
  private specificStates: any = [];
  
  private specificStateFields = DICE_QUOTES_CONFIG.SpecificStates;
  private officers = DICE_QUOTES_CONFIG.Officers;
  
  private docFiles: any = [];
  private supplementalFiles: any = [];
  private quotekeys: any = {
    applicationId: '',
    quoteId: ''
  };

  private loading: boolean = false;
  private isUMUIMCertify: boolean = false;
  private isUMUIMUploaded: boolean = false;
  private isWaiveTria: boolean = false;
  private isWaiveTriaCertify: boolean = false;
  private isExcludedOfficer: boolean = false;
  private isIncludedOfficer: boolean = false;
  private isValidBillingContact: boolean = true;
  private isValidWCAuditContact: boolean = true;
  private selectedBillingType: any;

  private isUMUIMFormRequired: boolean = false;
  private isWorkCompAdded: boolean = false;
  private uploadedFileSize: number = 0;
  private isAllDocTypesSelected = false;
  private workerOptions: any = [];

  private attachmentError: string = null;
  private triaWaiverError: string = null;
  private UMUIMFormError: string = null;

  private triaWaivers: any = [this.lobTypeEnum.Package];

  private bindNIssueFormSubmitted: boolean = false;

  private bindNIssueSubmitBtnClicked: boolean = false;

  private acknowledgementText: string = ""; // Using it in HTML
  private acceptAcknowledgement: boolean = false; // Using it in HTML
  private understandAcknowledgement: boolean = false; // Using it in HTML

  private defaultPerson: any = {
    caption: 'Select...',
    value: ''
  }
  private loadingPerson: any = {
    caption:'Loading...',
    value: ''
  }
  private noPersonAvailable: any = {
    caption:'No Person Available',
    value: ''
  }
  private personListLoading: boolean = false;

  private stateOfHire: any = '';
  private stateOfHireSelected: boolean = false;
  private stateOfHireOptions: any = [];
  private payrollServices: boolean = false;

  private diceQuoteMethod: DiceQuoteMethod = new DiceQuoteMethod();

  @ViewChild("bindAndIssueForm", {static: false}) bindNIssueForm: NgForm;
  @ViewChild("stateOfHireModal", {static: false}) stateOfHireModal;

  constructor(private diceService: DiceService, private commonService: CommonService, private router: Router, private route: ActivatedRoute, private calendar: NgbCalendar, private formatter: NgbDateParserFormatter, private el: ElementRef) { }

  ngOnInit() {
    this.headerData = new HeaderData();
    this.setHeaderData();

    this.setAcknowledgementText();

    this.getReferenceData();

    this.diceService.resetSupportingDocuments();
    this.acceptAcknowledgement = false;
    this.understandAcknowledgement = false;

    if(this.diceService.hasOpenModals()) {
      this.diceService.closeModal();
    }
  }

  setHeaderData(details?: any){
    this.headerData.pageTitle = "Issue Policies";

    if(details){
      this.headerData.detailMenu = [{label: "Account", description: this.quote.accountName}];
    }

    this.diceService.header = this.headerData;
  }

  getReferenceData() {
    this.lookupReferenceData = this.diceService.referenceData;

    console.log('this.lookupReferenceData :: ', this.lookupReferenceData);

    if(!this.lookupReferenceData) {
      this.fetchReferenceData();
    } else {
      this.getQuoteDetails();
      this.setSeparatePaymentPlanList();
    }
  }

  /*** Gets Application Key and Quote ID from URL Route / State Params  ***/
  getAppKeyandQuoteId() {
    this.route.paramMap.subscribe(params => {
      this.quotekeys.applicationId = params.get('key').toString();
      this.quotekeys.quoteId = params.get("id").toString();

      console.log("QuoteKeys :: ", this.quotekeys);
    });
  }

  /*** Fetch Lookup Reference Data to populate values on UI ***/
  fetchReferenceData() {
    this.loading = true;

    let referenceDataSubscription = this.diceService.fetchReferenceData().subscribe(response => {
      this.loading = false;
      this.lookupReferenceData = response;
      this.diceService.referenceData = response;

      this.getQuoteDetails();
      this.setSeparatePaymentPlanList();
    }, error=>{
      this.loading = false;
      this.getQuoteDetails();
    });

    this.diceService.runningServices.push(referenceDataSubscription);   
  }

  getQuoteDetails() {
    this.loading = true;
    this.getAppKeyandQuoteId();
    this.quoteResponse = this.diceService.diceQuoteDetailsData;
    console.log('this.quoteResponse :: ', this.quoteResponse);    

    if(!this.quoteResponse) {
      this.fetchQuoteDetails();
    } else {
      this.loading = false;
      
      console.log(this.quotekeys.applicationId + " ::: " + this.quoteResponse.application.applicationId);
      if(this.quotekeys.applicationId !== this.quoteResponse.application.applicationId || this.quotekeys.quoteId !== this.quoteResponse.quoteDetails.quoteId) {
        this.fetchQuoteDetails();
      } else {
        this.quote = this.quoteResponse.quoteDetails;
        this.application = this.quoteResponse.application;
        this.setHeaderData(this.quote);
        this.setInitialFormData();
      }
    }    
  }

  fetchQuoteDetails(){
    this.loading = true;

    let quoteDetailsSubscription = this.diceService.fetchQuoteDetails(this.quotekeys).subscribe(response => {
      this.quoteResponse = response;
      this.diceService.diceQuoteDetailsData = response;
      console.log('this.quoteResponse :: ', this.quoteResponse);
      console.log('this.diceService.diceQuoteDetailsData :: ', this.diceService.diceQuoteDetailsData);
      this.quote = this.quoteResponse.quoteDetails;
      this.application = this.quoteResponse.application;

      this.setHeaderData(this.quote);
      this.setInitialFormData();
      console.log("this.quote: ", this.quote);
      console.log("this.application: ", this.application);
    }, error => {
      this.setInitialFormData();
    });

    this.diceService.runningServices.push(quoteDetailsSubscription);
  }

  getTriaWaiversRequired(){
    this.triaWaivers = [this.lobTypeEnum.Package];
    this.quote.lobsPremium.forEach(lob => {
      if(lob.lobStatus == LobStatus.Quoted){
        if(lob.lobCode === LobCodes.AU || lob.lobCode === LobCodes.AUMA){
          if(this.lookupReferenceData.lobRules.AU.umStates.find(state=> state==this.diceQuoteMethod.getBusinessAddress(this.application).state)){
            this.isUMUIMFormRequired = true;
          }
        }
        if(lob.type !== this.lobTypeEnum.Package && lob.lobCode !== LobCodes.WC){
          this.triaWaivers.push(lob.lobName);
        }
      }
    });
  }

  setInitialFormData() {
    this.bindQuoteForm = new BindQuote();
    this.setCalendarDate();

    this.selectedBillingType = '';

    this.bindQuoteForm.applicationId = this.quotekeys.applicationId;    
    this.bindQuoteForm.quoteId = this.quotekeys.quoteId;

    if(!this.application.contact){
      this.auditContact = {
        firstName: null, lastName: null, roleName: 'Audit', email: null, phone: null
      };
      this.billingContact = {
        firstName: null, lastName: null, roleName: 'Billing', email: null, phone: null
      };
    }
    else{
      this.auditContact = {
        firstName: this.application.contact.firstName, lastName: this.application.contact.lastName, roleName: 'Audit', email: this.application.contact.email, phone: this.application.contact.phone
      };
      this.billingContact = {
        firstName: this.application.contact.firstName, lastName: this.application.contact.lastName, roleName: 'Billing', email: this.application.contact.email, phone: this.application.contact.phone
      };
    }

    this.isValidBillingContact = true;

    let pipe = new DatePipe('en-US');
    let _policyEffectiveDate = new Date(pipe.transform(this.quote.policyEffectiveDate, 'MM/dd/yyyy', 'UTC'));
    
    this.bindQuoteForm.policyEffectiveDate = this.formatter.format({year: _policyEffectiveDate.getFullYear(), month: _policyEffectiveDate.getMonth()+1, day: _policyEffectiveDate.getDate()});

    console.log('this.bindQuoteForm.policyEffectiveDate :: ', this.bindQuoteForm.policyEffectiveDate);

    this.isWorkCompAdded = this.checkIfQuoteHasWC();

    this.getTriaWaiversRequired();

    if(this.isWorkCompAdded && this.application.accountFein){
      this.bindQuoteForm.accountFein = this.application.accountFein;
    }

    setTimeout(()=>{
      this.loading = false;
      this.bindQuoteForm.accountName = this.quote.accountName;
    }, 100);

    console.log('this.auditContact :: ',this.auditContact);
    console.log('this.billingContact :: ',this.billingContact);

    console.log('this.bindQuoteForm  :: ', this.bindQuoteForm);
  }

  checkIfQuoteHasWC() {
    let isWorkComp: boolean = false;
    if(this.application && this.application.coverage) {
      this.application.coverage.loBs.forEach(lob => {
        if(lob.lobCode === LobCodes.WC) {
          isWorkComp = true;
          let status = this.quote.lobsPremium.find(lob=>lob.lobCode==LobCodes.WC).lobStatus;
          this.isWorkCompReferred = (status == LobStatus.Referred || status == LobStatus.Offline);
          if(!this.isWorkCompReferred){
            this.payrollServices = (lob.options[0].selectedOptions[1] && lob.options[0].selectedOptions[1].value == this.yesNoEnum.YES);
            this.getStateSpecificReq(lob);
          }
        }
      });
    }    

    return isWorkComp;
  }

  getStateSpecificReq(lob){
    this.bindQuoteForm.workerOptions = lob.options[0].workerOptions;
    this.bindQuoteForm.workerOptions.forEach(location=> {
      location.stateSpecificReq = {state: '', fields: []};
      let state = this.specificStateFields[location.workerLocation[2].value];
      if(state){
        state.fields.forEach(stateField => {
          let question = this.diceService.getReferenceData().lobBindQA.WC.find(option=>option.keyValueID == stateField.field);
          if(question){
            question.maxlength = stateField.maxlength;
            question.required = stateField.required;
            location.stateSpecificReq.state = state.stateLabel;
            location.stateSpecificReq.fields.push(question);
          }
        });
        this.specificStates.push(location);
      }
      location.selectedCity = location.workerLocation[0].value + ', ' + location.workerLocation[1].value + ', ' + location.workerLocation[2].value;
      if(location.workerPerson.length>0){ this.copyOfficers(location); }
    });
  }

  exemptMNFields(fields, exempt){
    exempt.value = this.isMNExempt.toString();
    fields.forEach(field => {
      if(field.keyValueID !== exempt.keyValueID){
        field.value = null;
        field.required = !this.isMNExempt;
      }
    });
  }

  copyOfficers(location){
    let options = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0];
    this.workerOptions.push(options);
    let currentOption = this.workerOptions[this.workerOptions.length-1];
    location.workerLocation.forEach(selection => {
      this.copySelections(currentOption.workerLocation, selection);
    });
    currentOption.selectedCity = currentOption.workerLocation[0].value + ', ' + currentOption.workerLocation[1].value + ', ' + currentOption.workerLocation[2].value;
    currentOption.workerPerson = [];
    location.workerPerson.forEach((personTab, personInd) => {
      this.addOfficerTab(personInd, currentOption);
      personTab.forEach(selection => {
        this.copySelections(currentOption.workerPerson[personInd], selection);
      });
    });
    this.getPersonsList(currentOption);
  }

  copySelections(questions, selection){
    let question = questions.find(option => {return option.keyValueID == selection.keyValueID});
    if(question){
      question.value = (question.optionType == EditorOptionTypeEnum.BOOLEAN && !question.displayOptions) ? (selection.value == 'true' ? true : false) : selection.value;
      question.additionalInfo = selection.additionalInfo; 
      question.selectedValues = selection.selectedValues; 
      if(question.displayOptions){
        question.displayOptions.forEach(_dispOpt => {
          if(_dispOpt.answer === question.value){
            _dispOpt.isSelected = true;
          }
        });
      }
    }
  }
  
  /*** Setting up calendar for Policy Effective Date on Coverages Form***/
  setCalendarDate() {
    let _policyEffectiveDate = new Date();
    _policyEffectiveDate.setDate(_policyEffectiveDate.getDate());

    let _date: NgbDate; 

    let _policyMaxDate = new Date();
    _policyMaxDate.setDate(_policyMaxDate.getDate() + this.policyDateMaxDays);

    this.policyEffectiveDate = {year: _policyEffectiveDate.getFullYear(), month: _policyEffectiveDate.getMonth() + 1, day: _policyEffectiveDate.getDate() };
    this.policyMaxDate = {year: _policyMaxDate.getFullYear(), month: _policyMaxDate.getMonth() + 1, day: _policyMaxDate.getDate() };
  }

  updateBillType(event, _billId) {
    this.bindQuoteForm.billingType = _billId;
    if(_billId === this.billingTypeEnum.Agency) {
      this.bindQuoteForm.paymentPlan = this.agencyPaymentPlans[0].values;
    } else {
      this.bindQuoteForm.paymentPlan = DefaultPaymentPlan.DefaultPlan;
    }
    console.log('this.bindQuoteForm.billingType :: ', this.bindQuoteForm.billingType);
  }

  setSeparatePaymentPlanList() {
    this.directPaymentPlans = [];
    this.lookupReferenceData.paymentPlans.forEach(plan => {
      if(plan.billingType === this.billingTypeEnum.Direct) {
        this.directPaymentPlans.push(plan);
      } else {
        this.agencyPaymentPlans.push(plan);
      }
    });

    console.log("Payment Plans !!!!");
    console.log(this.directPaymentPlans, " :: ", this.agencyPaymentPlans);
  }

  openStateOfHireModal(){
    this.stateOfHire = '';
    this.stateOfHireSelected = false;
    this.stateOfHireOptions = [];
    this.bindQuoteForm.workerOptions.forEach((location, ind) => {
      let duplicate = this.workerOptions.find(loc=> loc.selectedCity == location.selectedCity);
      if(!duplicate){
        this.stateOfHireOptions.push(this.bindQuoteForm.workerOptions[ind].selectedCity);
      }
    });

    if(this.stateOfHireOptions.length == 1){
      this.addOfficers(this.stateOfHireOptions[0]);
    } else{
      this.diceService.openModal('none', this.stateOfHireModal, true, 'light-blue-backdrop', true, '', '', true);
    }
  }

  addOfficers(selectedCity){
    this.stateOfHireSelected = true;
    if(selectedCity){
      let location = this.bindQuoteForm.workerOptions.find(location=> location.selectedCity == selectedCity);
      location.workerPerson = [];
      this.workerOptions.push(location);
      this.addOfficerTab(0, this.workerOptions[this.workerOptions.length-1]);
      this.getPersonsList(this.workerOptions[this.workerOptions.length-1]);
      this.diceService.closeModal();
    }
  }

  addOfficerTab(index: any, wcOptions) {
    let personQuestions = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerPerson[0];
    personQuestions = personQuestions.slice(0,2); //remove dynamic fields
    wcOptions.workerPerson.push(personQuestions);
    wcOptions.selectedOfficerTab = index;

    /* default select if only 1 option for included/excluded is available */
    if(wcOptions.persons && (wcOptions.persons.excludedPersons.length==0 || wcOptions.persons.includedPersons.length==0)){
      if(wcOptions.persons.excludedPersons.length==0){ //default select included when excluded is not available
        personQuestions[0].value = personQuestions[0].displayOptions[0].answer;
        personQuestions[0].displayOptions[0].isSelected = true;
      } else { //default select excluded when included is not available
        personQuestions[0].value = personQuestions[0].displayOptions[1].answer;
        personQuestions[0].displayOptions[1].isSelected = true;
      }
      this.updatePersonsList(personQuestions[0].value, wcOptions, wcOptions.workerPerson.length-1); //set persons list
    }

    //autoscroll officer tabs when adding new
    setTimeout(() => {
      let wcInd = (this.workerOptions.length>1) ? this.workerOptions.findIndex(option=>option==wcOptions) : 0;
      this.tabScroll('officer', 'end', wcInd);
    }, 100);  
  }

  removeOfficerTab(index, wcOptions){
    wcOptions.workerPerson.splice(index, 1);
    wcOptions.selectedOfficerTab = (index!==0) ? index-1 : 0;

    if(wcOptions.workerPerson.length>0){
      //check if scroll is active
      setTimeout(() => {
        let wcInd = (this.workerOptions.length>1) ? this.workerOptions.findIndex(option=>option==wcOptions) : 0;
        this.isScrollActive('officer', wcInd);
      }, 100);
    }
  }
  
  tabScroll(type, direction, wcIdx){
    let tab = document.getElementById(type+'-tabs'+wcIdx);
    if(tab){
      if(direction == 'right'){
        tab.scrollBy(500, 0);
      } else if(direction == 'left'){
        tab.scrollBy(-500, 0);
      } else{
        tab.scrollTo(tab.scrollWidth, 0);
      }
      setTimeout(() => {
        this.isScrollActive(type, wcIdx);
      }, 250);
    }
  }

  isScrollActive(type, wcIdx){
    let tab = document.getElementById(type+'-tabs'+wcIdx);
    let scrollLeft = document.getElementById(type+'-scroll-left'+wcIdx);
    let scrollRight = document.getElementById(type+'-scroll-right'+wcIdx);
    if((tab.scrollWidth - tab.scrollLeft) > tab.clientWidth){
      scrollRight.classList.add('scroll-active'); //make scroll blue
    } else {
      scrollRight.classList.remove('scroll-active'); //make scroll gray
    }
    if(tab.scrollLeft > 0){
      scrollLeft.classList.add('scroll-active'); //make scroll blue
    } else {
      scrollLeft.classList.remove('scroll-active'); //make scroll gray
    }
  }

  resetPersons(_tabs, _person){
    _tabs.forEach(tab => {
      tab[1].displayOptions = _person;
      tab[1].selectedPerson = tab[1].displayOptions[0];
    });
  }

  getPersonsList(_wcOption){
    /* copy quote - person list loading */
    if(_wcOption.workerPerson.length>0){
      this.personListLoading = true;
      this.resetPersons(_wcOption.workerPerson, [this.loadingPerson]);
    }

    let request = { effDate: new Date(this.bindQuoteForm.policyEffectiveDate), stateCode: _wcOption.workerLocation[2].value };
    let personListSubscription = this.diceService.fetchPersonList(request).subscribe((response:any) => {
      _wcOption.persons = response;
      
      /* copy quote - dynamic fields after persons list API returns success */
      let wcCopyOption = this.bindQuoteForm.workerOptions.find(location=> location.workerLocation[0].value == _wcOption.workerLocation[0].value && location.workerLocation[1].value == _wcOption.workerLocation[1].value);
      if(wcCopyOption && wcCopyOption.workerPerson.length > 0){
        _wcOption.workerPerson.forEach((personTab, tabInd) => {
          if(personTab[0].value){
            this.updatePersonsList(personTab[0].value, _wcOption, tabInd);
            this.updateOfficerFields(tabInd, _wcOption);
            wcCopyOption.workerPerson[tabInd].forEach(selection => {
              this.copySelections(_wcOption.workerPerson[tabInd], selection);
            });
          }
        });
      }
      this.personListLoading = false;
    }, error=>{
      if(_wcOption.workerPerson.length>0){
        this.resetPersons(_wcOption.workerPerson, [this.noPersonAvailable]);
      }
      if(this.diceService.hasOpenModals()) {
        this.diceService.closeModal();
      }
      this.diceService.openModal('error', 'none', false, 'light-blue-backdrop', false, '');
      this.personListLoading = false;
    });
    this.diceService.runningServices.push(personListSubscription);
  }

  updatePersonsList(_includedExcluded, _wcOption, _tabInd){
    _wcOption.workerPerson[_tabInd][1].selectedPerson = this.defaultPerson; //reset person type
    _wcOption.workerPerson[_tabInd] = _wcOption.workerPerson[_tabInd].slice(0,2); //reset dynamic fields
    let included = (_wcOption.persons.includedPersons.length>1) ? [this.defaultPerson].concat(_wcOption.persons.includedPersons) : _wcOption.persons.includedPersons;
    let excluded = (_wcOption.persons.excludedPersons.length>1) ? [this.defaultPerson].concat(_wcOption.persons.excludedPersons) : _wcOption.persons.excludedPersons;
    _wcOption.workerPerson[_tabInd][1].displayOptions = (_includedExcluded=='Included') ? included : excluded;
    _wcOption.workerPerson[_tabInd][1].selectedPerson = _wcOption.workerPerson[_tabInd][1].displayOptions[0]; //default select first in list
    if(_wcOption.workerPerson[_tabInd][1].selectedPerson && _wcOption.workerPerson[_tabInd][1].selectedPerson.value){
      this.updateOfficerFields(_tabInd, _wcOption);
    }
  }

  updateOfficerFields(_tabInd, _wcOption){
    _wcOption.workerPerson[_tabInd] = _wcOption.workerPerson[_tabInd].slice(0,2); //reset dynamic fields
    if(_wcOption.workerPerson[_tabInd][1].selectedPerson.value){
      _wcOption.workerPerson[_tabInd][1].value = _wcOption.workerPerson[_tabInd][1].selectedPerson.value;
      _wcOption.workerPerson[_tabInd][1].additionalInfo = _wcOption.workerPerson[_tabInd][1].selectedPerson.caption; //caption for review page
    } else {
      let selected = _wcOption.workerPerson[_tabInd][1].displayOptions.find(person=> person.value == _wcOption.workerPerson[_tabInd][1].value);
      _wcOption.workerPerson[_tabInd][1].selectedPerson = (selected) ? selected : '';
    }

    let role = _wcOption.workerPerson[_tabInd][1].selectedPerson.caption;
    let included = _wcOption.workerPerson[_tabInd][0].value == 'Included';
    let state = _wcOption.workerLocation[2].value;
    let fields = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerPerson[0];
    
    /* add dynamic fields based on role, included/excluded, and state */
    let question = Object.values(this.officers).find((person:any)=>(person.caption && role.startsWith(person.caption))).field;
    _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == question));

    if(state == 'CA' || state == 'NY' || state == 'PA'){
      _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == this.officers.Title.field));
      if(state == 'PA' && !included){
        _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == this.officers.Ownership.field));
        if(role == this.officers.Officers.fullCaption){
          _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == this.officers.ShortenedTitle.field));
        }
      }
    }
  }

  attachOfficerWaiver(wcIdx, tabInd){
    document.getElementById('officerWaiverFile'+wcIdx+''+tabInd).click();
  }

  checkTriaWaiverUploaded(lob){
    return !(this.supportingDocuments.findIndex(file=> file.triaType && file.triaType == lob) == -1);
  }

  updateTriaWaivers($event){
    this.isWaiveTria = $event.target.checked;
    if(!this.isWaiveTria){ //remove waivers if user decides to no longer waive TRIA
      for(let i=0; i<this.supportingDocuments.length; i++){
        if(this.supportingDocuments[i].documentType == this.documentFileTypeEnum.TriaWaiver){
          this.removeDocument(this.supportingDocuments[i].documentType, this.supportingDocuments[i].uniqueName);
          i--;
        }
      }
    }
  }

  fileBrowseHandler(files) {
    this.uploadAllDocuments(files, null, true, null);
  }

  uploadAllDocuments(files, _docFileType, isSupplementalDocs, _officerTabId, _officerTabContent=null){
    console.log('files :: ', files);

    if(files.currentTarget && files.currentTarget.files){
      files = files.currentTarget.files;
    }

    if (files.length == 0) {
      console.log("No file selected!");
      return;
    }
    
    if(this.attachmentError !== this.errorMessages.attachmentDocTypes){
      this.attachmentError = null;
    }

    let allDocuments = this.diceService.getSupportingDocuments();
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });

    Array.from(files).forEach((_file:any)=>{
      if(_docFileType !== this.lobTypeEnum.Package && _docFileType !== LOBTypeDisplayName.AU && _docFileType !== LOBTypeDisplayName.IM && _docFileType !== LOBTypeDisplayName.UMB){
        _file.documentType = _docFileType;
      } else {
        _file.documentType = this.documentFileTypeEnum.TriaWaiver;
        _file.triaType = _docFileType;
      }
      _file.uniqueName = (Math.random() * 1000000000).toFixed(0);
      if(_file.size>0 && (this.uploadedFileSize+(Number(_file.size))) < this.fileUploadConfig.MaxUploadSize){
        this.uploadedFileSize+=(Number(_file.size));
        this.diceService.addSupportingDocument(_file);
        if(isSupplementalDocs) {
          this.supplementalFiles.push(_file);
        }
        if(_file.documentType == this.documentFileTypeEnum.OfficerWaivers){
          _file.tabId = _officerTabId;
          _officerTabContent[0].isOfficerWaiverUploaded = true;
          _officerTabContent[0].officerWaiverError = null;
        } else if(_file.documentType == this.documentFileTypeEnum.TriaWaiver){
          this.triaWaiverError = null;
        } else if(_file.documentType == this.documentFileTypeEnum.UMUIMForm){
          this.UMUIMFormError = null;
          this.isUMUIMUploaded = true;
        }
      }else{
        if(_file.size == 0){
          console.log("File has no content");
          if(_file.documentType == this.documentFileTypeEnum.TriaWaiver){
            this.triaWaiverError = this.fileUploadConfig.AttachmentNoContent;
          }else if(_file.documentType == this.documentFileTypeEnum.OfficerWaivers){
            _officerTabContent[0].officerWaiverError = this.fileUploadConfig.AttachmentNoContent;
            _officerTabContent[0].isOfficerWaiverUploaded = false;
          } else if(_file.documentType == this.documentFileTypeEnum.UMUIMForm){
            this.UMUIMFormError = this.fileUploadConfig.AttachmentNoContent;
            this.isUMUIMUploaded = false;
          } else {
            this.attachmentError = this.fileUploadConfig.AttachmentNoContent;
          }
        }else{
          console.log("File size exceeding");
          if(_file.documentType == this.documentFileTypeEnum.TriaWaiver){
            this.triaWaiverError = this.fileUploadConfig.AttachmentExceeds;
          }else if(_file.documentType == this.documentFileTypeEnum.OfficerWaivers){
            _officerTabContent[0].officerWaiverError = this.fileUploadConfig.AttachmentExceeds;
            _officerTabContent[0].isOfficerWaiverUploaded = false;
          } else if(_file.documentType == this.documentFileTypeEnum.UMUIMForm){
            this.UMUIMFormError = this.fileUploadConfig.AttachmentExceeds;
            this.isUMUIMUploaded = false;
          } else {
            this.attachmentError = this.fileUploadConfig.AttachmentExceeds;
          }
        }
      }
    });
    console.log('this.uploadedFileSize :: ', this.uploadedFileSize);

    this.supportingDocuments = this.diceService.getSupportingDocuments();

    console.log('this.supportingDocuments :: ', this.supportingDocuments);
    console.log('this.supplementalFiles :: ', this.supplementalFiles);
  }

  removeDocument( _docFileType, _uniqueName, _officerTabContent=null){
    let allDocuments = this.diceService.getSupportingDocuments();
    let fileIndex = allDocuments.findIndex(_docFile=>{return _docFile.uniqueName == _uniqueName});
    this.diceService.getSupportingDocuments().splice(fileIndex, 1);
    this.updateFileType();
    
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });

    if(_docFileType == this.documentFileTypeEnum.TriaWaiver){
      this.triaWaiverError = null;
    }else if(_docFileType == this.documentFileTypeEnum.OfficerWaivers){
      _officerTabContent[0].officerWaiverError = null;
      _officerTabContent[0].isOfficerWaiverUploaded = false;
    }else if(_docFileType == this.documentFileTypeEnum.UMUIMForm){
      this.UMUIMFormError = null;
      this.isUMUIMUploaded = false;
    }else if(this.uploadedFileSize < this.fileUploadConfig.MaxUploadSize && this.isAllDocTypesSelected){
      this.attachmentError = null;
    }
  }

  setAllDocumentsToUpload() {
    if(this.supportingDocuments.length > 0){
        this.supportingDocuments.forEach((document, index) => {
          let newFile:any = {};
          newFile.fileName= document.name;
          newFile.lastModified= document.lastModified;
          newFile.lastModifiedDate= document.lastModifiedDate;
          newFile.webkitRelativePath= document.webkitRelativePath;
          newFile.size= document.size;
          newFile.fileType= document.type;
          newFile.documentType = document.documentType;

          ((_document, _newFile)=>{
            let fReader = new FileReader();
            // Add complete behavior
            fReader.onload = ()=>{
              _newFile.contentStream = fReader.result;
              _newFile.contentStream = _newFile.contentStream.split("base64,")[1];

              //console.log(_newFile.content);
              this.docFiles.push(_newFile);

              this.bindQuoteForm.attachments = this.docFiles;

              if(this.bindQuoteForm.attachments.length == this.supportingDocuments.length){
                this.submitRequest();
              }else{
                console.log("uploading file " + index);
              }
            };
            fReader.readAsDataURL(_document);
          })(document, newFile);   
      });
    }
  }

  getSupportingDocuments(_docFileType){
    let docFiles = this.diceService.getSupportingDocuments().filter(_docFile=>{return _docFile.docFileType == _docFileType});

    return docFiles;
  }

  setFileIcon(file: any){
    return this.commonService.setFileIcon(file);
  }

  updateFileType(_docType = null, _fileidx = null) {
    let _isDocTypeSelected = true;

    for(let i=0; i < this.supplementalFiles.length; i++) {
      console.log('Document Type ::: ', this.supplementalFiles[i].documentType);
      if(this.supplementalFiles[i].documentType === null) {
        _isDocTypeSelected = false;
      }
    }
    
    if(_fileidx) {
      console.log('_event.target.value :: ', _docType);
      this.supplementalFiles[_fileidx].documentType = _docType;
    }

    this.isAllDocTypesSelected = _isDocTypeSelected;
    if(this.bindNIssueSubmitBtnClicked){
      this.attachmentError = (this.supplementalFiles.length>0 && !this.isAllDocTypesSelected) ? this.errorMessages.attachmentDocTypes : null;
    }
  }

  removeListItem(_index){
    this.supplementalFiles.forEach(document=>{
      this.docFiles.forEach((_file, _docIdx) => {
        if(document.fileName === _file.fileName && document.documentType === _file.documentType) {
          this.docFiles.splice(_docIdx, 1);
        }
      });

      console.log('this.docFiles :: ', this.docFiles);
    });
    setTimeout(()=>{
      this.supplementalFiles.splice(_index, 1);
      this.updateFileType();
      if(this.uploadedFileSize < this.fileUploadConfig.MaxUploadSize && this.isAllDocTypesSelected){
        this.attachmentError = null;
      }
    }, 100);

    console.log('this.docFiles :: ', this.docFiles);
  }

  checkValidContact(contact){  
    if(contact.firstName  && contact.lastName  && contact.phone && contact.email && this.bindNIssueForm.valid) {
      return true;
    } 
    else if((contact.firstName === null || contact.firstName === undefined || contact.firstName === '') && 
    (contact.lastName === null ||  contact.lastName === undefined || contact.lastName === '') && 
    (contact.phone === null || contact.phone === undefined || contact.phone === '') && 
    (contact.email === null || contact.email === undefined || contact.email === '')) {
      return true;
    } 
    else {
      return false;
    }
  }

  setAcknowledgementText(){
    this.acknowledgementText = `<p><b>NOTICE</b></p>
    
    <p><b>Applicable in AL, AR, DC, LA, MD, NM, RI and WV:</b> Any person who knowingly (or willfully)* presents a false or fraudulent claim for payment of a loss or benefit or knowingly (or willfully)* presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison. *Applies in MD Only.</p>
    
    <p><b>Applicable in CO:</b> It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, denial of insurance and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the policyholder or claimant with regard to a settlement or award payable from insurance proceeds shall be reported to the Colorado Division of Insurance within the Department of Regulatory Agencies.</p>
    
    <p><b>Applicable in FL and OK:</b> Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application containing any false, incomplete, or misleading information is guilty of a felony (of the third degree)*. *Applies in FL only.</p>
    
    <p><b>Applicable in KS:</b> Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or belief that it will be presented to or by an insurer, purported insurer, broker or any agent thereof, any written, electronic, electronic impulse, facsimile, magnetic, oral or telephonic communication or statement as part of, or in support of, an application for the issuance of, or the rating of an insurance policy for personal or commercial insurance, or a claim for payment or other benefit pursuant to an insurance policy for commercial or personal insurance which such person knows to contain materially false information concerning any fact material thereto; or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act.</p>
    
    <p><b>Applicable in KY, NY, OH and PA:</b> Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties (not to exceed five thousand dollars and the stated value of the claim for each such violation)*. *Applies in NY only.</p>
    
    <p><b>Applicable in ME, TN, VA and WA:</b> It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties (may)* include imprisonment, fines and denial of insurance benefits. *Applies in ME only.</p>
    
    <p><b>Applicable in NJ:</b> Any person who includes any false or misleading information on an application for an insurance policy or who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.</p>
    
    
    <p><b>Applicable in Utah:</b> Any person who knowingly presents false or fraudulent underwriting information, files or causes to be filed a false or fraudulent claim for disability compensation or medical benefits, or submits a false or fraudulent report or billing for health care fees or other professional services is guilty of a crime and may be subject to fines and confinement in state prison.</p>
    
    <p><b>Applicable in OR:</b> Any person who knowingly and with intent to defraud or solicit another to defraud the insurer by submitting an application or filing a claim containing a false statement as to any material fact may be violating state law.</p>

    <p><b>CERTIFICATION AND ACKNOWLEDGEMENT</b></p>

    <p>The undersigned/user is an authorized representative of the applicant and represents that reasonable inquiry has been made to obtain the answers to questions on this application. He/she represents that the answers are true, correct and complete to the best of his/her knowledge. The applicant or authorized representative acknowledge and understand that he/she is authorized to make any inquiry it deems appropriate in its sole discretion in connection with this application. Acceptance of this application does not obligate the insurer to issue the insurance being requested hereby, nor does it obligate the applicant to acquire such insurance.</p>
    
    <p>The undersigned/user is an authorized representative of the applicant and acknowledges that, should any of the information or statements contained in this application or in any attachments hereto change in any material respect between the date of the application and the effective date of the policy to be issued in connection with such application, the insurer shall have the right, in its sole discretion, to amend, modify or withdraw any outstanding quotation or agreement to bind insurance. Further, the authorized representative or the applicant undertakes to inform the insurer as promptly as possible of any material change or alteration to such information and statements, whether occurring before or after the issuance of an insurance policy in connection herewith.</p>
    `
  }
  
  checkTabInvalid(wcIdx, tabInd){
    let form = document.getElementById('officer'+wcIdx+''+tabInd);
    if(this.bindNIssueSubmitBtnClicked && form){
      let tab = document.getElementById('officer-tab' + wcIdx + '' + tabInd);
      if(form.getElementsByClassName('ng-invalid').length>0){
        this.workerOptions[wcIdx].selectedOfficerTab = tabInd; //select officer tab with errors
        form.classList.add('error-content'); //make form border red
        tab.classList.add('error-tab'); //make tab title red
      } else {
        form.classList.remove('error-content'); //make form border gray
        tab.classList.remove('error-tab'); //make tab title black
      }
    }
  }

  checkCOIRequired(){
    if(this.bindNIssueSubmitBtnClicked && !this.isWorkCompReferred){
      if(this.payrollServices){ 
        if((this.supplementalFiles.length==0 || !this.supplementalFiles.find(file=>file.documentType == this.documentFileTypeEnum.COI)) && (this.application && (this.application.attachments.length==0 || !this.application.attachments.find(file=>file.documentType == this.documentFileTypeEnum.COI)))){
          this.attachmentError = this.errorMessages.COIRequired;
          return true;
        }
      }
      return false;
    } else { return false; }
  }

  submitForBind() {
    this.bindNIssueSubmitBtnClicked = true;

    let attachmentsLength = this.supplementalFiles.length;
    if(attachmentsLength > 0) {      
      this.updateFileType();
      this.bindQuoteForm.attachments = this.supplementalFiles;
    } else {
      this.isAllDocTypesSelected = true;
    }

    setTimeout(() => {
      /* check for officer tab errors */
      if(this.isWorkCompAdded && !this.isWorkCompReferred && this.workerOptions.length>0){
        for(let i=0; i<this.workerOptions.length; i++){
          if(this.workerOptions[i].workerPerson.length>0){
            for(let k=0; k<this.workerOptions[i].workerPerson.length; k++){
              this.checkTabInvalid(i, k);
            }
          }
        }
      }

      setTimeout(() => {
        const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
        if(formGroupInvalid.length>0){
          (<HTMLElement>formGroupInvalid[0]).focus();
          return;
        } else if(this.personListLoading){ 
          document.getElementsByClassName('officer-tabs')[0].scrollIntoView();
          return;
        }

        console.log('bindAndIssueForm : ', this.bindNIssueForm.valid, this.bindNIssueForm.submitted);

        this.isValidBillingContact = this.checkValidContact(this.billingContact);
        if(this.isWorkCompAdded) this.isValidWCAuditContact = this.checkValidContact(this.wcAuditContact);

        this.bindNIssueFormSubmitted = this.bindNIssueForm.valid;    

        if(this.bindNIssueFormSubmitted  && this.isAllDocTypesSelected && this.acceptAcknowledgement && this.understandAcknowledgement) {
          if(this.supportingDocuments.length > 0 ) { 
            this.setAllDocumentsToUpload();
          }else{
            this.submitRequest();
          }
        }
      }, 100);
    }, 100);
  }

  submitRequest(){    
    this.bindQuoteForm.contacts.push(this.auditContact);
    if(this.isWorkCompAdded && (this.wcAuditContact.firstName && this.wcAuditContact.lastName && this.wcAuditContact.phone && this.wcAuditContact.email)) {
      this.bindQuoteForm.contacts.push(this.wcAuditContact);
    }
    if(this.billingContact.firstName && this.billingContact.lastName && this.billingContact.phone && this.billingContact.email) {
      this.bindQuoteForm.contacts.push(this.billingContact);
    }

    if(this.isWorkCompAdded && !this.isWorkCompReferred){
      if(this.specificStates.length>0){
        let stateQuestions = [];
        this.specificStates.forEach(state => {
          state.stateSpecificReq.fields.forEach(question => {
            if(question.value){
              stateQuestions.push(question); //send only the state specific questions that were answered by the user
            }
          });
        });
        this.bindQuoteForm.lobBindQA = { WC: stateQuestions }; //set bind state specific questions for submit
      }
      this.bindQuoteForm.workerOptions.forEach(option => {
        let optionWithOfficers = this.workerOptions.find(location=> location.selectedCity == option.selectedCity);
        if(optionWithOfficers){
          option.workerPerson = optionWithOfficers.workerPerson; //set officers for submit
        } else {
          option.workerPerson = []; //reset officers
        }
      });
    }

    this.diceService.diceBindDetailsData = this.bindQuoteForm;
    console.log('this.bindQuoteForm.policyEffectiveDate :: ', this.bindQuoteForm.policyEffectiveDate);

    console.log('Submit bindQuoteForm : ', this.bindQuoteForm);    
    
    if(this.isValidBillingContact && (!this.isWorkCompAdded || (this.isWorkCompAdded && this.isValidWCAuditContact))) {
      if(this.bindQuoteForm.accountFein && this.bindQuoteForm.accountFein.indexOf("-")>-1){
        this.bindQuoteForm.accountFein = this.bindQuoteForm.accountFein.replace("-","");
      }
      //this.setInitialFormData();
      this.router.navigateByUrl("newbusiness/dice/confirmrate/" + this.bindQuoteForm.applicationId + "/" + this.bindQuoteForm.quoteId);
    }
  }
  
  gotoUrl(_url) {
    this.router.navigate([_url], {state: {selectedBusiness: NewBusiness.DICE}});
  }

  gotoQuoteList() {
    this.setInitialFormData();
    this.bindNIssueForm.reset();
    this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.DICE}});
  }

  ngOnDestroy() {
    this.diceService.runningServices.forEach(subscription => subscription.unsubscribe());
  }
}